@if (template && !(loading$ | async)) {
    <div [innerHTML]="template | safeHtml"></div>
}